import { Group } from "./Group";
export class LubricationTable {
    constructor(idLubricationTable?:string,group?:Group,idVehicle?:string,product?:any,qta?:number,note?:string){
        (idLubricationTable != undefined) ? this.idLubricationTable = idLubricationTable : this.idLubricationTable = null;
        (!group || group == undefined) ? this.group = new Group() : this.group = group;
        (!product) ? this.product = null : this.product = product;
        (idVehicle != undefined) ? this.idVehicle = idVehicle : this.idVehicle = null;
        (qta != undefined) ? this.qta = qta : this.qta = null;
        (note != undefined) ? this.note = note : this.note = null;
    }
    public idLubricationTable:string;
    public group: Group;
    public product:any;
    public idVehicle:string;
    public qta:number;
    public note:string;

    // public idLubricationTable: string | null = null;
    // public group: Group | null = null;
    // public vehicle: Vehicle | null = null;
    // public product: any;
    // public qta: number | null = null;
    // public note:string | null = null;
}


